import React, { useState } from 'react'


interface Props {
  size?: number;
}
const Divider: React.FC<Props> = (props) => {
  return (<div className="bg-divider w-full" style={{height: props.size}}/>)
}

Divider.defaultProps = {
  size: 1
}


export default Divider;